import { QuestionTypeEnum } from '__generatedTypes__/globalTypes'
import { findOneQuestion_findOneQuestion as Question } from '__generatedTypes__/findOneQuestion'
import { FormState } from './consts'
import { convertAnswerToRxWritingAnswer, EMPTY_RX_WRITING_ANSWER } from './RxWritingAnswers/helpers'
import { convertAnswerToNumericResponseAnswer, EMPTY_NUMERIC_RESPONSE_ANSWER } from './NumericResponseAnswer/helpers'
import {
  convertAnswerToTextCompletionAnswer,
  createTextCompletionBlank,
  getTextCompletionBlanksCountOption,
} from './TextCompletionAnswers/helpers'

export { parseRxWritingAnswerHtml, convertAnswerToRxWritingAnswer } from './RxWritingAnswers/helpers'
export { parseNumericResponseAnswerHtml, convertAnswerToNumericResponseAnswer } from './NumericResponseAnswer/helpers'
export { parseTextCompletionAnswerHtml, convertAnswerToTextCompletionAnswer } from './TextCompletionAnswers/helpers'

const emptyJsonAnswers = (): Pick<
  FormState,
  'rxWritingAnswer' | 'numericResponseAnswer' | 'textCompletionAnswer' | 'textCompletionBlanksCount'
> => ({
  rxWritingAnswer: [EMPTY_RX_WRITING_ANSWER],
  numericResponseAnswer: EMPTY_NUMERIC_RESPONSE_ANSWER,
  textCompletionAnswer: [createTextCompletionBlank()],
  textCompletionBlanksCount: getTextCompletionBlanksCountOption(1),
})

export const parseAnswers = (
  type: QuestionTypeEnum,
  answers?: Question['answer']
): Pick<
  FormState,
  'rxWritingAnswer' | 'numericResponseAnswer' | 'textCompletionAnswer' | 'textCompletionBlanksCount'
> => {
  switch (type) {
    case QuestionTypeEnum.RxWritingNDEB: {
      const rxWritingAnswer = convertAnswerToRxWritingAnswer(answers)

      return {
        ...emptyJsonAnswers(),
        rxWritingAnswer: rxWritingAnswer.length ? rxWritingAnswer : [EMPTY_RX_WRITING_ANSWER],
      }
    }
    case QuestionTypeEnum.NumericResponse:
      return {
        ...emptyJsonAnswers(),
        numericResponseAnswer: convertAnswerToNumericResponseAnswer(answers),
      }
    case QuestionTypeEnum.TextCompletion: {
      const textCompletionAnswer = convertAnswerToTextCompletionAnswer(answers)

      return {
        ...emptyJsonAnswers(),
        textCompletionAnswer,
        textCompletionBlanksCount: getTextCompletionBlanksCountOption(textCompletionAnswer.length),
      }
    }
    default:
      return emptyJsonAnswers()
  }
}
